jQuery = require('jquery');
angular = require('angular');
moment = require('moment');
enviroment = require('./development/assets/app/js/enviroment.js');
if(!enviroment.isDevelopment) {
  // ============================================================================
// SENTRY ERROR TRACKING & MONITORING SETUP
// ============================================================================
// Initialize Sentry for error tracking
// All Sentry logic is centralized in sentryIntegration.js
// ============================================================================
  var sentryIntegration = require('./development/assets/app/js/sentryIntegration.js');
  sentryIntegration.init();
} 
EXIF = require("./development/assets/custom-external-script/exif.js");
Dropzone = require("./development/assets/custom-external-script/dropzone.js");
Promise = require('promise-polyfill');
QRCode = require('qrcode')
// io = require('../node_modules/socket.io-client/dist/socket.io.js');
owasp = require('owasp-password-strength-test');
slugify = require('slug-generator');
window.diff_match_patch = require('diff-match-patch');
intersectionObserverGlobal = require('./development/assets/app/js/initObs.js')
require('angular-ui-router');
require('angular-resource');
require('angular-sanitize');
require('oi.select')
require('underscore');
require('jquery-ui-bundle');
require('../node_modules/bootstrap/dist/js/bootstrap.js')
require('../node_modules/angular-bootstrap/ui-bootstrap-tpls.js');
// require('../node_modules/angular-socket-io/socket.js');
require('./development/assets/custom-external-script/jquery.touch.min.js');
require('./development/assets/custom-external-script/ng-table.js');
require('../node_modules/ng-storage/ngStorage.min.js');
require('./development/assets/custom-external-script/daterangepicker.js');
require('./development/assets/custom-external-script/ng-bs-daterangepicker.js');
require('./development/assets/custom-external-script/ngdropzone.js');
require('../node_modules/tinymce/tinymce');
require('./development/assets/custom-external-script/tinymce/core-overrides.js');
require('../node_modules/tinymce/themes/modern/theme');
require('../node_modules/tinymce/plugins/anchor/plugin');
require('../node_modules/tinymce/plugins/autoresize/plugin');
require('../node_modules/tinymce/plugins/lists/plugin');
require('../node_modules/tinymce/plugins/link/plugin')
require('./development/assets/custom-external-script/tinymce/plugins/custom-link/plugin.js');
require('../node_modules/tinymce/plugins/image/plugin');
require('../node_modules/tinymce/plugins/fullscreen/plugin');
require('../node_modules/tinymce/plugins/hr/plugin');
require('../node_modules/tinymce/plugins/textcolor/plugin');
require('../node_modules/tinymce/plugins/paste/plugin');
require('./development/assets/custom-external-script/angular-diff-match-patch/angular-diff-match-patch');
// require('../node_modules/tinymce/plugins/insertdatetime/plugin');
require('./development/assets/custom-external-script/tinymce/plugins/pagebreak/plugin');
require('./development/assets/custom-external-script/angular-ui-tinymce/tinymce');
require('./tinymce/custom-tinymce.css');
require('../node_modules/angular-ui-tree/dist/angular-ui-tree.js');
require('../node_modules/angular-slugify/angular-slugify.js');
require('../node_modules/croppie/croppie.js');
require('angular-ui-sortable');
wpautop = require('./development/assets/custom-external-script/wpautop');
window.Highcharts = require('../node_modules/highcharts/highstock.js');
window.videojs = require('video.js');
// require('../node_modules/videojs-contrib-hls/dist/videojs-contrib-hls.min.js');
var tinycolor = require("tinycolor2");
require('./development/assets/custom-external-script/angularjs-color-picker.js');
require('./home.scss');
require('./development/assets/ext-modules/servicesModule/servicesModule.js');
require('./development/assets/ext-modules/loginModule/js/loginModule.js');
require('./development/assets/ext-modules/dashboardModule/dashboardModule.js');
require('./development/assets/ext-modules/postsModule/postsModule.js');
// require('./development/assets/ext-modules/blogsModule/blogsModule.js');
// require('./development/assets/ext-modules/newsServicesModule/newsServicesModule.js');
require('./development/assets/ext-modules/ratingModule/ratingModule.js');
require('./development/assets/ext-modules/mediaModule/mediaModule.js');
require('./development/assets/ext-modules/pagesModule/pagesModule.js');
require('./development/assets/ext-modules/approvalsModule/approvalsModule.js');
require('./development/assets/ext-modules/aiModule/aiModule.js');
require('./development/assets/ext-modules/usersModule/usersModule.js');
require('./development/assets/ext-modules/pollsModule/pollsModule.js');
require('./development/assets/ext-modules/notificationsModule/notificationsModule.js');
require('./development/assets/ext-modules/commentsModule/commentsModule.js');
// require('./development/assets/ext-modules/focusModule/focusModule.js');
// require('./development/assets/ext-modules/newstickerModule/newstickerModule.js');
require('./development/assets/ext-modules/popularpostsModule/popularpostsModule.js');
require('./development/assets/ext-modules/macrositesModule/macrositesModule.js');
require('./development/assets/ext-modules/menusModule/menusModule.js');
require('./development/assets/ext-modules/logsModule/logsModule.js');
require('./development/assets/ext-modules/videoModule/videoModule.js');
// require('./development/assets/ext-modules/eSportsModule/eSportsModule.js');
require('./development/assets/ext-modules/adsModule/adsModule.js');
// require('./development/assets/ext-modules/wCupModule/wCupModule.js');
// require('./development/assets/ext-modules/covidRestrictionsModule/covidRestrictionsModule.js');
// require('./development/assets/ext-modules/blicModule/blicModule.js');
// require('./development/assets/ext-modules/catalogsModule/catalogModule.js');
require('./development/assets/app/js/app.js');

// ============================================================================
// SENTRY TEST CONTROLLER (Development Only)
// ============================================================================
// Load this AFTER Sentry is initialized and app.js is loaded
// Get the 'app' module from Angular since it's already registered
// This provides a test panel for manually testing Sentry integration
// Only loads in development, automatically hidden in production
// ============================================================================
// if (window.location.hostname === 'localhost' || window.location.hostname.includes('dev')) {
//   // Get the Angular app module that was registered in app.js
//   var app = angular.module('app');
//   require('./development/assets/app/js/sentryTestController.js')(app);
//   console.log('🧪 Sentry Test Controller loaded (development mode)');
// }
// ============================================================================




//////////////////
// WEBPACK FOOTER
// ./public/entry.js
// module id = 0
// module chunks = 0